export enum REQUEST_TYPE {
  PERMISO_POR_HORAS = 1,
  PERMISO_POR_DIAS = 2,
  RESERVA_VACACIONES = 3,
  EDICION_MARCAS = 4,
  CAMBIO_DE_HORARIO = 5,
  HORAS_EXTRAS = 6,
  HORAS_COMPENSACION = 7,
  HORAS_RECUPERACION = 8,
  HORAS_AVANCE = 9,
  VENTA_VACACIONES = 10,
  LACTANCIA = 11,
  DESCANSO_MEDICO_POR_HORAS = 12,
  PATERNIDAD = 13,
  MATERNIDAD = 14,
  BENEFICIO_POR_HORAS = 15,
  SIN_GOCE_DE_HABER_POR_HORAS = 16,
  DESCANSO_MEDICO_POR_DIAS = 17,
  BENEFICIO_POR_DIAS = 18,
  SIN_GOCE_DE_HABER_POR_DIAS = 19,
  TRABAJO_REMOTO_POR_HORAS = 20,
  TRABAJO_REMOTO_POR_DIAS = 21,
  ADELANTO_DE_VACACIONES = 22,
  CON_GOCE_DE_HABER_POR_HORAS = 23,
  CON_GOCE_DE_HABER_POR_DIAS = 24,
  VENCIMIENTO_TOLERANCIA = 25,
  REGISTRO_MARCAS = 27,
  ELIMINACION_MARCAS = 28,
}